import { get } from 'lodash';

import { FIELD_PATHS, VISIT_CONTACT_TYPE } from '@funnels/constants';
import { RelatedParty } from '@funnels/types';

export const hasPropertyContactToCopy = (relatedParties: RelatedParty[], relatedPartyIndex: number) =>
  relatedParties.some(
    (relatedParty, index) =>
      // check if this is a related party for property
      !!get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_ASSET_ID(0)) &&
      // check if this has a contact type of visit contact type (minimum requirement for copying from)
      Object.values(VISIT_CONTACT_TYPE).includes(
        get({ relatedParties: [relatedParty] }, FIELD_PATHS.RELATED_PARTY_TYPE(0))
      ) &&
      // check if this is other related party available for copying
      index !== relatedPartyIndex
  );
